import {
  EPrescriptionStatus,
  IGetPrescriptionsResponse,
  IGetPrescriptionByIdResponse,
  IMappedPrescription,
  IPrescriptionDetailsResponse,
  IPrescriptionResponse,
  IMappedPrescriptionDetails,
} from "./prescriptions.interface";

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

const mapPrescription = (prescription: IPrescriptionResponse): IMappedPrescription => {
  const status = prescription.displayStatus.toUpperCase() as EPrescriptionStatus;

  return {
    id: prescription.id,
    name: prescription.name,
    itemId: prescription.itemId,
    status,
    petId: prescription.petId,
    petName: prescription.petName,
    prescribedAt: formatDate(prescription.prescribedAt),
    expirationDate: formatDate(prescription.expirationDate),
    prescribedBy: prescription.prescribedBy,
  };
};

const mapPrescriptionDetails = (prescription: IPrescriptionDetailsResponse): IMappedPrescriptionDetails => {
  if (!prescription) {
    return {
      id: "",
      name: "",
      itemId: "",
      status: EPrescriptionStatus.NO_REFILLS_REMAINING,
      petId: "",
      petName: "",
      prescribedAt: "",
      expirationDate: "",
      prescribedBy: "",
      allowedUse: 0,
      quantity: 0,
      remainingFills: 0,
      instructions: "",
      dose: "",
    };
  }

  const status = prescription.displayStatus.toUpperCase() as EPrescriptionStatus;

  return {
    id: prescription.id,
    name: prescription.name,
    itemId: prescription.itemId,
    status,
    petId: prescription.petId,
    petName: prescription.petName,
    prescribedAt: formatDate(prescription.prescribedAt),
    expirationDate: formatDate(prescription.expirationDate),
    prescribedBy: prescription.prescribedBy,
    allowedUse: prescription.allowedUse,
    quantity: prescription.quantity,
    remainingFills: prescription.remainingFills,
    instructions: prescription.instructions,
    dose: prescription.dose,
  };
};

export const mapPrescriptionsResponse = (data?: IGetPrescriptionsResponse) => {
  if (!data) {
    return {
      prescriptions: [],
      hasMore: false,
      success: false,
    };
  }

  const prescriptions = data.getOnlinePharmacyPrescriptions?.prescriptions.map(mapPrescription) ?? [];
  const hasMore = data.getOnlinePharmacyPrescriptions?.hasMore ?? false;
  const success = data.getOnlinePharmacyPrescriptions?.success ?? false;

  return { prescriptions, hasMore, success };
};

export const mapPrescriptionDetailsResponse = (data?: IGetPrescriptionByIdResponse) => {
  const prescription = data?.getOnlinePharmacyPrescriptionById?.prescription;
  return {
    prescription: mapPrescriptionDetails(prescription as IPrescriptionDetailsResponse),
  };
};
